// Keep Umi's locale registry lightweight. Complete messages are loaded on demand
// from `localeBundles/zh-CN` during application startup.
export default {};
